import { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Button } from '@components/ui';

const API_URL = import.meta.env.VITE_API_URL || '/api';

export default function LoginPage({ onLogin, error: externalError }) {
  const [isLoading, setIsLoading] = useState(false);

  const handleMicrosoftLogin = () => {
    setIsLoading(true);
    // Redirect to backend Microsoft OAuth endpoint
    window.location.href = `${API_URL}/auth/microsoft`;
  };

  const error = externalError;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-800 to-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src={`${API_URL}/uploads/logoI.jpeg`}
            alt="JIROX"
            className="w-16 h-16 rounded-2xl mx-auto mb-4 object-cover"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
          <h1 className="text-2xl font-bold text-white">JIROX</h1>
          <p className="text-slate-400 mt-1">Project Manager</p>
        </div>

        <Card>
          <h2 className="text-xl font-bold text-slate-800 mb-6 text-center">Iniciar Sesión</h2>

          {error && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm mb-4">
              {error}
            </div>
          )}

          <Button
            onClick={handleMicrosoftLogin}
            variant="primary"
            className="w-full"
            loading={isLoading}
          >
            <span className="flex items-center justify-center gap-2">
              <svg className="w-5 h-5" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1" y="1" width="9" height="9" fill="#F25022"/>
                <rect x="11" y="1" width="9" height="9" fill="#7FBA00"/>
                <rect x="1" y="11" width="9" height="9" fill="#00A4EF"/>
                <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
              </svg>
              {isLoading ? 'Redirigiendo...' : 'Iniciar sesión con Microsoft'}
            </span>
          </Button>
        </Card>
      </div>
    </div>
  );
}

LoginPage.propTypes = {
  onLogin: PropTypes.func.isRequired,
  error: PropTypes.string,
};
